module.exports = __webpack_public_path__ + "img/Grupo 1639.30c8b2fb.svg";